import React from 'react';
import { Card, Switch, Badge, Space, Typography } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

/**
 * Карточка для управления рассылкой
 * @param {Object} notification - объект настройки рассылки
 * @param {Function} onToggle - функция переключения состояния
 * @param {Boolean} loading - состояние загрузки
 */
const NotificationCard = ({ notification, onToggle, loading }) => {
  const handleToggle = (checked) => {
    onToggle(notification.type, checked);
  };

  return (
    <Card
      hoverable
      style={{
        borderRadius: '8px',
        height: '100%',
        border: `1px solid ${notification.isEnabled ? '#52c41a' : '#d9d9d9'}`,
      }}
      bodyStyle={{ padding: '20px' }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {/* Заголовок с Badge */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={5} style={{ margin: 0 }}>
            {notification.name}
          </Title>
          <Badge
            status={notification.isEnabled ? 'success' : 'default'}
            text={notification.isEnabled ? 'Активно' : 'Неактивно'}
          />
        </div>

        {/* Описание */}
        <Text type="secondary" style={{ fontSize: '14px' }}>
          {notification.description}
        </Text>

        {/* Номер телефона (если есть) */}
        {notification.phoneNumber && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <PhoneOutlined style={{ color: '#1890ff' }} />
            <Text strong style={{ fontSize: '14px' }}>
              {notification.phoneNumber}
            </Text>
          </div>
        )}

        {/* Переключатель */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
          <Text>Отправка сообщений:</Text>
          <Switch
            checked={notification.isEnabled}
            onChange={handleToggle}
            loading={loading}
            checkedChildren="Вкл"
            unCheckedChildren="Выкл"
          />
        </div>
      </Space>
    </Card>
  );
};

export default NotificationCard;

